import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { EventService } from "@perxis-auto/shared/lib";
import "react-router";
import "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import { APP_EVENTS, APP_EVENT_BUTTON_IDS } from "../../../shared/config/events.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../features/comparison/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import { useGetComparableVehicles } from "../../../features/comparison/lib/useGetComparableVehicles.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { actions } from "../../../features/comparison/model/slice.js";
const useContainer = (item) => {
  const { redirects, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const eventService = EventService.getInstance();
  const totalCompared = useAppSelector((state) => selectors.selectTotal(state.comparison));
  const { isLoading, isUninitialized } = useGetComparableVehicles();
  const onClearClick = useCallback(() => {
    dispatch(actions.removeAllItems());
    eventService.sendEvent(APP_EVENTS.ButtonClicked, {
      id: APP_EVENT_BUTTON_IDS.REMOVE_ALL_FROM_COMPARISON
    });
  }, [dispatch]);
  const onBackClick = useCallback(() => {
    navigate(redirects.onBackClick.to, redirects.onBackClick.options);
    eventService.sendEvent(APP_EVENTS.ButtonClicked, {
      id: APP_EVENT_BUTTON_IDS.BACK_TO_LIST_FROM_COMPARISON_PAGE
    });
  }, [navigate, redirects.onBackClick.options, redirects.onBackClick.to]);
  return {
    ...props,
    onClearClick,
    onBackClick,
    total: totalCompared,
    isLoading: isLoading || isUninitialized,
    t
  };
};
export {
  useContainer
};
